import axios from "axios";
export const insertRole = async (roleData) => {
  try {
    const response = await axios.post("http://localhost:8080/webnet-hms/api/roles/add", roleData);
    window.alert("Roles inserted successfully:", response.data);
    return response.data;
  } catch (error) {
    window.alert("Error inserting roles:", error);
  }
};